import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import List from './List'
import New from './New'
import Edit from './Edit'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_CONCEPTS } from 'app-support/permissions/Permissions'
import { conceptsRoute, conceptsRouteEdit, conceptsRouteNew } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(conceptsRoute)

const ConceptsContainer = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_CONCEPTS} exact path={conceptsRoute} component={List} />
    <PermissionRoute permission={PERMISSION_MANAGE_CONCEPTS} exact path={conceptsRouteNew} component={New} />
    <PermissionRoute permission={PERMISSION_MANAGE_CONCEPTS} exact path={conceptsRouteEdit} component={Edit} />
  </Switch>
)

export default enhance(ConceptsContainer)
